import { render, staticRenderFns } from "./coreFunction.vue?vue&type=template&id=c2cf02cc&scoped=true&"
import script from "./coreFunction.vue?vue&type=script&lang=js&"
export * from "./coreFunction.vue?vue&type=script&lang=js&"
import style0 from "./coreFunction.vue?vue&type=style&index=0&id=c2cf02cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cf02cc",
  null
  
)

export default component.exports